export default {
  getFunnels: _state => _state.funnels,
  getAvailableLabels: _state => _state.availableLabels,
  getSelectedFunnelId: _state => _state.selectedFunnelId,
  // Getter para obter o objeto funil completo a partir do ID selecionado
  getSelectedFunnel: _state => {
    if (!_state.selectedFunnelId) return null;
    return _state.funnels.find(f => f.id === _state.selectedFunnelId);
  },
  getCardsByLabel: _state => _state.cardsByLabel,
  // Getter para obter os cards de uma label específica
  getCardsForLabel: _state => labelId => _state.cardsByLabel[labelId] || [],
  // Getter para obter meta dados de uma label (paginação, total)
  getMetaForLabel: _state => labelId =>
    (_state.cardsMeta && _state.cardsMeta[labelId]) || {
      total_count: 0,
      page: 1,
      has_more: false,
    },
  isLoading: _state => flag => _state.loading[flag] || false, // Ex: isLoading('cards')
  getError: _state => flag => _state.error[flag] || null,
};
